
import React from "react";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

interface InternalRecipientsGroupProps {
  internalRecipients: {
    group1: boolean;
    group2: boolean;
  };
  onInternalCheckboxChange: (group: 'group1' | 'group2') => void;
}

const InternalRecipientsGroup = ({
  internalRecipients,
  onInternalCheckboxChange
}: InternalRecipientsGroupProps) => {
  return (
    <div className="space-y-2">
      <Label>Ontvangers</Label>
      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="internal-group2"
            checked={internalRecipients.group2}
            onCheckedChange={() => onInternalCheckboxChange('group2')}
          />
          <Label 
            htmlFor="internal-group2" 
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Inkoop
          </Label>
        </div>
      </div>
    </div>
  );
};

export default InternalRecipientsGroup;
